export default __webpack_public_path__ + "static/realWorldImg4-54b9096c16531ca97796b51a023e9aca.webp";